import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=1b463918&scoped=true&"
import script from "./checkbox-group.ts?vue&type=script&lang=ts&"
export * from "./checkbox-group.ts?vue&type=script&lang=ts&"
import style0 from "./checkbox-group.scss?vue&type=style&index=0&id=1b463918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b463918",
  null
  
)

export default component.exports